// Quantity-based bulk/wholesale pricing (mirrors backend effective_price)
export function effectivePrice(product, qty, opts = {}) {
  let price = product.price;
  if (opts.wholesale && product.wholesale_price) price = product.wholesale_price;
  const tiers = (product.bulk_tiers || [])
    .filter((t) => qty >= (t.min_qty || 0))
    .sort((a, b) => (b.min_qty || 0) - (a.min_qty || 0));
  if (tiers.length) price = tiers[0].price;
  return price;
}

// Delivery: per-product delivery_charge (highest) > area (district/upazila) > global default.
export function deliveryCharge(items, settings, district, upazila) {
  if (!items || items.length === 0) return 0;
  const perProduct = items
    .map((i) => (i.product || i).delivery_charge)
    .filter((v) => v !== null && v !== undefined && v !== "")
    .map(Number);
  if (perProduct.length) return Math.max(...perProduct);
  const areas = settings?.area_delivery || [];
  if (district) {
    const exact = areas.find((a) => a.district === district && a.upazila && a.upazila === upazila && a.charge != null);
    if (exact) return Number(exact.charge);
    const distOnly = areas.find((a) => a.district === district && !a.upazila && a.charge != null);
    if (distOnly) return Number(distOnly.charge);
  }
  return Number(settings?.delivery_charge ?? 60);
}

export function lowestTier(product) {
  const tiers = (product.bulk_tiers || []).slice().sort((a, b) => (a.min_qty || 0) - (b.min_qty || 0));
  return tiers[0] || null;
}
